import React from 'react';

function WinModal({ onReset, onMenu, onNextLevel, level }) {
  const TOTAL_LEVELS = 10; // Match LevelsModal.jsx
  const isLastLevel = level >= TOTAL_LEVELS;

  return (
    <div className="absolute flex items-center justify-center w-full h-full bg-black bg-opacity-50">
      <div className="relative bg-gray-900/90 p-6 rounded-xl text-center max-w-[280px] sm:max-w-[320px] landscape:max-w-[360px] filter drop-shadow-[0_0_10px_rgba(0,255,255,0.4)]">
        <h2 className="text-lg sm:text-xl landscape:text-lg text-cyan-300 font-medium mb-4">
          Congratulations, Level {level} Complete!
        </h2>
        <div className="flex justify-center gap-3">
          <button
            onClick={onReset}
            className="bg-transparent border border-cyan-500 text-cyan-300 text-sm sm:text-base landscape:text-sm font-medium py-2 px-5 rounded-full transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-200 hover:shadow-[0_0_12px_rgba(0,255,255,0.5)]"
          >
            Reset
          </button>
          <button
            onClick={() => onNextLevel(level + 1)}
            disabled={isLastLevel}
            className={`bg-transparent border border-cyan-500 text-sm sm:text-base landscape:text-sm font-medium py-2 px-5 rounded-full transition-all duration-300 ${
              isLastLevel
                ? 'text-cyan-600 border-cyan-600 cursor-not-allowed'
                : 'text-cyan-300 hover:bg-cyan-500/10 hover:text-cyan-200 hover:shadow-[0_0_12px_rgba(0,255,255,0.5)]'
            }`}
          >
            Next Level
          </button>
          <button
            onClick={onMenu}
            className="bg-transparent border border-cyan-500 text-cyan-300 text-sm sm:text-base landscape:text-sm font-medium py-2 px-5 rounded-full transition-all duration-300 hover:bg-cyan-500/10 hover:text-cyan-200 hover:shadow-[0_0_12px_rgba(0,255,255,0.5)]"
          >
            Menu
          </button>
        </div>
      </div>
    </div>
  );
}

export default WinModal;